import Link from 'next/link'
import { useState } from 'react'
import React from 'react'
import { useRouter } from 'next/router'
import Template from '@app/components/template'
import { translate } from '@app/locale/translate'
import Alert, { getNetworkError } from '@app/components/alert'
import { EMAIL_REGEX } from '@app/components/utils'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { login } from '@app/store'

import { useForm } from 'react-hook-form'
import { Flex, Box, Button, Text } from 'rebass'
import Theme from '@app/styles/theme'

import {
  Label,
  Input,
  Checkbox
} from '@rebass/forms'

const Login = ({ city, login, query }) => {
  const router = useRouter()
  // Use router.query (available on both SSR and client) with query prop as fallback
  const [emailConfirmed, setEmailConfirmed] = useState(query?.email_confirmed || router.query?.email_confirmed)

  const { register, errors, handleSubmit } = useForm()

  const [loginError, setLoginError] = useState()
  const [errorMessage, setErrorMessage] = useState({})

  // Update emailConfirmed when router.query becomes available
  React.useEffect(() => {
    if (router.query?.email_confirmed) {
      setEmailConfirmed(router.query.email_confirmed)
    }
  }, [router.query])

  const onSubmit = data => {
    login(
      data.email,
      data.password,
      city.slug,
      'profile performer venue',
      (userdata) => {
        router.push('/dashboard')
      },
      (err) => {
        // console.log('failed to login', err )
        if(err.status === 400) {
          setLoginError(translate("The user with that email and password could not be found."))
        }
        else {
          setErrorMessage(getNetworkError(err))
        }
      }
    )
  }

  return (
    <Template>
      <Flex
        width={1}
        justifyContent='center'
      >
        <Box
          as='form'
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            maxWidth: 450,
            flexGrow: 1
          }}
        >
          {emailConfirmed === '1' && (
            <Text
              width={1}
              textAlign='center'
              p={3}
              bg="accent"
              color="white"
              my={3}
              sx={{
                border: '1px solid',
                borderColor: 'accent',
                borderRadius: '4px'
              }}
            >
              {translate('✓ Email confirmed successfully! Please log in to continue.')}
            </Text>
          )}

          <Box
            my={16}>
            <Label mb={2} htmlFor='email'>{translate('Email')}</Label>
            <Input
              id='email'
              name='email'
              placeholder='yourname@gmail.com'
              ref={register({
                required: true,
                pattern: EMAIL_REGEX
              })}
            />
            <Text fontSize={1} color='accent'>{errors.email && translate("Invalid email address")}</Text>
          </Box>
          <Box
            my={16}>
            <Label mb={2} htmlFor='password'>{translate('Password')}</Label>
            <Input
              id='password'
              name='password'
              type='password'
              ref={register({
                required: true,
                minLength: 8
              })}
              onChange={()=>{
                if(loginError) setLoginError(null)
              }}
            />
            <Text fontSize={1} color='accent'>{errors.password && translate("password must be at least 8 characters")}</Text>
            <Text fontSize={1} color='accent'>{loginError}</Text>
          </Box>
          <Flex
            alignItems='center'
            justifyContent='space-between'
            my={16}
          >
            <Label lineHeight={1.5}>
              <Checkbox
                id='remember'
                name='remember'
              />
              {translate('Remember Me')}
            </Label>
            <Link href='/account/forgot'>
              <a className="link" style={{ color: Theme.colors.primary }}>{translate('Forgot Password')}?</a>
            </Link>
          </Flex>
          <Button type="submit">{translate('Login')}</Button>
        </Box>
      </Flex>
      <Alert
        open={errorMessage.title !== undefined}
        title={errorMessage.title}
        message={errorMessage.message}
        onClose={() => { setErrorMessage({}) }}
      ></Alert>
    </Template>
  )
}

const mapStateToProps = state => ({
  city: state.city
})

const mapDispatchToProps = dispatch => ({
  login: bindActionCreators(login, dispatch)
})

Login.getInitialProps = async (context) => {
  return {
    query: context.query
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
